import styled from "styled-components";
import Colors from "../../themes/Colors";

const RegionLangHolder = styled.div`
  padding: 5px 8px 5px 8px;
  border-radius: 8px;
  background-color: ${Colors.surfaceMuted};
  
  
  .regionButton{
    border-color: "transparent";
  }

  }
`;

export default RegionLangHolder;
